<template>
    <div class="audit">
        <div @click="$router.push('/homePage')" class="prev-box">
            <span class="el-icon-arrow-left"></span>
            <span>
                返回
            </span>
        </div>
        <div class="table-box">
            <div class="scach-box">
                <div class="left-box">
                    <el-input size="small" @keyup.enter.native="() => getUserList('seach')" placeholder="请输入考生姓名或身份证号手机号"
                        suffix-icon="el-icon-search" v-model="listParams.searchContent">
                    </el-input>
                    <el-select size="small" @change="() => getUserList('seach')" v-model="listParams.searchApplyStatus"
                        placeholder="请选择审核状态">
                        <el-option label="全部" :value="-1">
                        </el-option>
                        <el-option label="未审核" :value="1">
                        </el-option>
                        <el-option label="通过" :value="2">
                        </el-option>
                        <el-option label="未通过" :value="3">
                        </el-option>
                    </el-select>
                </div>
                <div class="right-box">
                    <!-- <el-button 
                        size="small"
                        type="primary">
                        上传对照表
                    </el-button> -->
                    <el-button size="small" @click="bindingPlan" type="primary">
                        绑定计划
                    </el-button>
                    <el-dropdown split-button type="primary" size="small" trigger="click" @command="exportScore">
                        导出成绩
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-for="item in planList" :key="item.examPlanId" :command="item.examPlanId">{{
                                item.examPlanName }}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button size="small" @click="queryExport" type="primary">
                        查询导出
                    </el-button>
                    <el-button size="small" @click="() => exportFlex('imageZip')" type="primary">
                        导出照片
                    </el-button>
                    <el-button size="small" @click="() => exportFlex('studentInfo')" type="primary">
                        导出学生信息
                    </el-button>
                    <el-upload :show-file-list="false" class="upload-demo" :action="uploadData.action"
                        :on-success="fileUploadSuccess" :on-error="fileUploadError">
                        <el-button size="small" type="primary">上传对照表</el-button>
                    </el-upload>
                    <el-button size="small" @click="userAllCheck" type="primary">
                        全部通过
                    </el-button>
                    <el-button @click="userBatchCheck" size="small" type="primary">
                        批量通过
                    </el-button>
                </div>
            </div>
            <el-table :data="tableData" border @selection-change="handleSelectionChange" :height="tableHeight"
                style="width: 100%">
                <el-table-column type="selection" width="55">
                </el-table-column>
                <el-table-column prop="indexNo" label="序号" width="60">
                </el-table-column>
                <el-table-column prop="provinceName" label="省份" width="100">
                </el-table-column>
                <el-table-column prop="name" label="考生姓名" width="150">
                </el-table-column>
                <el-table-column prop="pinyin" label="姓名拼音" width="200">
                </el-table-column>
                <el-table-column prop="orgName" label="学校" width="260">
                </el-table-column>
                <el-table-column prop="major" label="专业" width="200">
                </el-table-column>
                <el-table-column prop="mobile" label="手机号码" width="150">
                </el-table-column>
                <el-table-column prop="idCard" label="身份证号" width="180">
                </el-table-column>
                <el-table-column prop="createTime" label="注册时间" width="220">
                </el-table-column>
                <el-table-column prop="applyStatusName" label="状态" width="100">
                    <template slot-scope="scope">
                        <span v-html="scope.row.applyStatusName"></span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" prop="operation" min-width="240" label="操作">
                    <template slot-scope="scope">
                        <div class="table-col-button">
                            <!-- <el-button 
                                @click="()=>{oprtation(scope.row, 'show')}"
                                type="text">
                                查看证件
                            </el-button> -->
                            <el-button @click="() => { oprtation(scope.row, 'check', 2) }" type="text">
                                通过审核
                            </el-button>
                            <el-button @click="() => { oprtation(scope.row, 'check', 3) }" type="text">
                                不通过
                            </el-button>
                            <el-button @click="() => { oprtation(scope.row, 'show', null, scope.$index) }" type="text">
                                查看照片
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-box">
            <el-pagination :hide-on-single-page="true" :total="listParams.total" :page-size="listParams.limitSize"
                background :current-page.sync="listParams.pageNo" @current-change="getUserList" layout="prev, pager, next">
            </el-pagination>
        </div>
        <el-dialog v-if="activeIndex !== -1" :title="tableData[activeIndex].name" :visible.sync="imageDialog"
            :close-on-click-modal="false" :close-on-press-escape="false" width="300px" center>
            <div style="min-height: 160px;">
                <el-image style="width: 100px; margin-left: 74px;" :src="tableData[activeIndex].photoUrl"
                    :preview-src-list="srcList" fit="fill">
                </el-image>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="() => activeIndex--" :disabled="!activeIndex" size="mini">
                    <span class="el-icon-back"></span>
                </el-button>
                <el-button @click="downloadFile" size="mini">
                    <span class="el-icon-download"></span>
                </el-button>
                <el-button @click="() => activeIndex++" :disabled="activeIndex === tableData.length - 1" size="mini">
                    <span class="el-icon-right"></span>
                </el-button>
            </span>
        </el-dialog>
        <el-dialog center :visible.sync="exportRouleVisible" width="583px" title="导出规则">
            <div class="form-box">
                <el-row>
                    <el-col :span="6">
                        <span class="label_name">
                            就读院校
                        </span>
                    </el-col>
                    <el-col :span="18">
                        <el-select v-model="exportParam.orgId" filterable placeholder="请选择就读院校" clearable size="mini"
                            value-key="deptId">
                            <el-option label="全部" :value="-1"></el-option>
                            <el-option v-for="item in orgDataList" :key="item.deptId" :label="item.name"
                                :value="item.deptId"></el-option>
                        </el-select>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6">
                        <span class="label_name">
                            时间控制
                        </span>
                    </el-col>
                    <el-col :span="18">
                        <el-radio v-model="exportParam.byTime" :label="0" size="mini" border>
                            关闭
                        </el-radio>
                        <el-radio v-model="exportParam.byTime" :label="1" size="mini" border>
                            开启
                        </el-radio>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6">
                        <span class="label_name">
                            时间范围
                        </span>
                    </el-col>
                    <el-col :span="18">
                        <el-date-picker size="mini" value-format="yyyy-MM-dd HH:mm:ss" v-model="exportParam.allTime"
                            type="datetimerange" :disabled="exportParam.byTime === 0" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期">
                        </el-date-picker>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6">
                        <span class="label_name">
                            学生状态
                        </span>
                    </el-col>
                    <el-col :span="18">
                        <el-select v-model="exportParam.searchApplyStatus" filterable placeholder="" size="mini">
                            <el-option label="全部" :value="-1"></el-option>
                            <el-option label="未提交" :value="0"></el-option>
                            <el-option label="申请中" :value="1"></el-option>
                            <el-option label="已通过" :value="2"></el-option>
                            <el-option label="未通过" :value="3"></el-option>
                        </el-select>
                    </el-col>
                </el-row>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="exportRouleVisible = false" size="small">
                    取消
                </el-button>
                <el-button @click="exportNextClick" type="primary" size="small">
                    确定
                </el-button>
            </span>
        </el-dialog>
        <el-dialog center :visible.sync="queryExportVisible" width="583px" title="查询导出">
            <span v-if="!dialoadUrl">
                正在生成压缩包，请稍后查询
            </span>
            <div v-else class="form-box">
                <el-row>
                    <el-col :span="6">
                        <span class="label_name">
                            下载地址
                        </span>
                    </el-col>
                    <el-col :span="18">
                        <el-input size="mini" readonly v-model="dialoadUrl" onfocus="this.removeAttribute('readonly');">
                        </el-input>
                    </el-col>
                </el-row>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="queryExportVisible = false" size="small">
                    取消
                </el-button>
                <el-button @click="queryExportVisible = false" type="primary" size="small">
                    确定
                </el-button>
            </span>
        </el-dialog>
        <!-- <el-image 
            style="width: 100px; height: 100px"
            :src="imgViewUrl" 
            ref="imgView"
            class="img-view"
            :preview-src-list="srcList">
        </el-image> -->
        <el-dialog center :visible.sync="bingingPlanVisible" width="583px" title="绑定计划">
            <div class="form-box">
                <el-row>
                    <el-col :span="6">
                        <span class="label_name">
                            选择计划
                        </span>
                    </el-col>
                    <el-col :span="18">
                        <el-radio v-model="planFlag" border size="mini" :label="0">练习计划</el-radio>
                        <el-radio v-model="planFlag" border size="mini" :label="1">正式计划</el-radio>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6">
                        <span class="label_name">
                            当前选中计划
                        </span>
                    </el-col>
                    <el-col :span="18">
                        {{ examPlanData && examPlanData.sysCode }} - {{ examPlanData && examPlanData.examPlanName }}
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6">
                        <span class="label_name">
                            计划列表
                        </span>
                    </el-col>
                    <el-col :span="18" class="planListCol">
                        <el-input size="mini" readonly v-model.trim="planDataValue" placeholder="请输入 计划名称 或者 计划编码  进行查询~"
                            @change="changePlanData" style="margin-bottom: 10px;"
                            onfocus="this.removeAttribute('readonly');">
                        </el-input>
                        <el-radio-group v-model="examPlanData" class="planRadioGroup">
                            <el-radio border class="planRadio" size="mini" v-for="(item, idx) in examKwPlanList" :key="idx"
                                :label="item" :title="item.examPlanName">{{ item.sysCode }} - {{ item.examPlanName
                                }}</el-radio>
                        </el-radio-group>
                    </el-col>
                </el-row>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="() => { bingingPlanVisible = false }" size="small">
                    取消
                </el-button>
                <el-button @click="bingingPlanConfirm" type="primary" size="small">
                    确定
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import auditFetch from '@/api/auditUrl'
import { getStore } from '@/utils/common.js'
// import { download } from '../homePage'
export default {
    name: 'audit',
    data() {
        return {
            bingingPlanVisible: false,
            planFlag: null,
            examPlanData: null,
            examKwPlanList: [],
            examKwPlanListCopy: [],
            planDataValue: '',
            tableData: [],
            listParams: {
                searchContent: '',//搜索的内容, 姓名、身份证、电话
                searchApplyStatus: -1, //搜索的状态  -1是全部     1-未审核 2-已通过 3-未通过 
                pageNo: 1,   // 页码
                total: 0,
                provinceId: 14,
                limitSize: 100  // 每页显示数量
            },
            imageDialog: false,
            imgViewUrl: '',
            srcList: [],
            selectList: [],
            uploadData: {
                action: auditFetch.uploadCheckAutoCheck + '?provinceId=14'
            },
            activeIndex: -1,
            exportRouleVisible: false,
            queryExportVisible: false,
            currentExportType: null,
            dialoadUrl: '',
            exportParam: {
                allTime: [],
                provinceId: 14,
                searchContent: '', //选填  为空即可
                searchApplyStatus: -1, // 必填  -1: 全部 0-未提交 1-申请中 2-已通过 3-未通过
                orgId: -1, //必填  -1-全部   其他-院校id
                byTime: 0, //必填   0-不按时间条件 1-按时间条件
                beginTime: '', // 当byTime=1时为必传 格式为"2023-12-23 12:00:00'
                endTime: '' // 当byTime=1时为必传  格式 为 "2023-12-31 23:00:00'
            },
            orgDataList: [],
            planList: [],
            examPlanId: ''
        }
    },
    computed: {
        tableHeight() {
            let pxH = this.listParams.total > 100 ? 215 : 170
            return `calc(100vh - ${pxH}px)`
        }
    },
    watch: {
        'exportParam.byTime'(newVal) {
            if (newVal === 0) {
                this.exportParam.allTime = []
            }
        },
        'bingingPlanVisible'(val) {
            if (!val) {
                this.bingingPlanVisible = false; this.examPlanData = null; this.examKwPlanList = []; this.planFlag = null; this.planDataValue = ''
            }
        }
    },
    mounted() {
        let userData = JSON.parse(sessionStorage.getItem('userData'))
        if (userData.isSys === 0) {
            this.getUserList()
        } else {
            this.$message.error('请不要试图修改地址！')
            this.$router.push('/')
        }
        this.getExamPlanList()
    },
    methods: {
        changePlanData(val) {
            if (!val) this.examKwPlanList = this.examKwPlanListCopy
            this.examKwPlanList = this.examKwPlanListCopy.filter(item => item.examPlanName.includes(val) || item.sysCode.includes(val))
        },
        bingingPlanConfirm() {
            if (!this.examPlanData || this.planFlag != 0 && !this.planFlag) {
                this.$message.error('请选择计划~')
                return false
            }

            this.$confirm('此操作会造成现有计划数据重置，确定要绑定吗？', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    auditFetch.setExamPlan({
                        provinceId: 14,
                        examPlanId: this.examPlanData.examPlanId,
                        examPlanName: this.examPlanData.examPlanName,
                        planFlag: this.planFlag
                    }).then(res => {
                        if (res.code == '0') {
                            this.bingingPlanVisible = false
                            // this.examPlanData = null
                            // this.planDataValue = ''
                            // this.examKwPlanList = []; this.planFlag = null; this.planDataValue = ''
                            this.$message.success(res.msg)
                        } else {
                            this.$message.error(res.msg)
                        }
                    })

                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '操作已取消。'
                    })
                });

        },
        // 绑定计划
        bindingPlan() {
            this.bingingPlanVisible = true
            this.$nextTick(() => {
                auditFetch.getKwExamPlan({}).then(res => {
                    if (res.code == '0') {
                        this.examKwPlanList = res.data || []
                        this.examKwPlanListCopy = Object.assign(this.examKwPlanList, [])
                    } else {
                        this.$message.error(res.msg)
                    }
                })
            });
        },
        // 获得审核列表
        getUserList(type) {
            if (type === 'seach') {
                this.listParams.pageNo = 1
            }
            this.activeIndex = -1
            auditFetch.getUserList(this.listParams).then(res => {
                if (res.code === '0') {
                    let data = res.data
                    let applyStatusList = {
                        1: {
                            statusName: '未审核',
                            color: '#a3a3a3'
                        },
                        2: {
                            statusName: '通过',
                            color: '#6183ff'
                        },
                        3: {
                            statusName: '不通过',
                            color: '#ff3b3b'
                        }
                    }
                    this.srcList = []
                    this.tableData = data.records && data.records.length ? data.records.map((item, index) => {
                        let statusData = applyStatusList[item.applyStatus] || {
                            statusName: '未审核',
                            color: '#a3a3a3'
                        }
                        this.srcList.push(item.photoUrl)
                        return {
                            ...item,
                            indexNo: ++index + ((this.listParams.pageNo - 1) * 100),
                            applyStatusName: `<span style="color: ${statusData.color}">${statusData.statusName}</span>`
                        }
                    }) : []
                    this.listParams.total = data.total
                    // this.listParams.total = 200
                }
            })
        },
        // 表格选中变动
        handleSelectionChange(selectList) {
            this.selectList = selectList
        },
        getExamPlanList() {
            auditFetch.examPlanList({ provinceId: 14 }).then(res => {
                if (res.code === '0') {
                    this.planList = res.data
                }
            })
        },
        //查询导出
        queryExport() {
            let userData = (JSON.parse(getStore('userData') || '{}')) || {}
            auditFetch.exportPhotoStatus({
                userId: userData.id
            }).then(res => {
                if (res.code === '0') {
                    if (res.data) {
                        this.queryExportVisible = true
                        this.dialoadUrl = res.data && res.data.url
                    } else {
                        this.$message.error('当前尚未进行过导出操作!')
                    }

                } else {
                    this.dialoadUrl = ''
                }
            })
        },
        // 选择完计划 导出成绩
        exportScore(examPlanId) {
            this.exportFlex('exportScore')
            this.examPlanId = examPlanId
        },
        // 获取导出机构列表
        getOrgList() {
            auditFetch.orgList({
                provinceId: 14
            }).then(res => {
                if (res.code === '0') {
                    // console.log(res);
                    this.orgDataList = res.data
                }
            })
        },
        // 导出照片 或 学生信息
        exportFlex(type) {
            this.getOrgList();
            this.exportRouleVisible = true
            this.currentExportType = type
        },
        // 导出规则确定
        exportNextClick() {
            if (this.exportParam.byTime === 1 && !this.exportParam.allTime.length) {
                // 按照时间
                this.$message.warning('请选择时间！')
                return false
            }
            let allTime = this.exportParam.allTime
            let userData = (JSON.parse(getStore('userData') || '{}')) || {}
            let obj = {
                ...this.exportParam,
                beginTime: allTime[0] || '2023-12-23 12:00:00', // 当byTime=1时为必传 格式为"2023-12-23 12:00:00'
                endTime: allTime[1] || '2023-12-23 12:00:00',
                examPlanId: this.examPlanId
            }
            delete obj.allTime
            let parmsStr = Object.keys(obj).map(key => key + '=' + (obj[key] || obj[key] === 0 ? obj[key] : '')).join('&');
            if (this.currentExportType === 'imageZip') {
                // 照片导出
                auditFetch.exportPhoto({
                    ...obj,
                    userId: userData.id,
                    tag: +new Date()
                }).then(res => {
                    if (res.code === '0') {
                        this.$message.success(res.msg)
                        this.exportRouleVisible = false
                    } else {
                        this.$message.error(res.msg || '未知异常')
                    }
                })

            } else if (this.currentExportType === 'exportScore') {
                // 导出成绩
                auditFetch.exportFile(auditFetch.exportScore + `?${parmsStr}`, {}, 'get').then(data => {
                    let url = window.URL.createObjectURL(new Blob([data], { type: 'UTF-8' }))
                    let link = document.createElement('a')
                    link.style.display = 'none'
                    link.href = url
                    link.setAttribute('download', this.examPlanId + '.xlsx')    // 自定义下载文件名（如exemple.txt）
                    document.body.appendChild(link)
                    // this.errorData.errorButton = false
                    link.click()
                })
            } else {
                auditFetch.exportFile(auditFetch.exportData + `?${parmsStr}`, {}, 'get').then(data => {
                    let url = window.URL.createObjectURL(new Blob([data], { type: 'UTF-8' }))
                    let link = document.createElement('a')
                    link.style.display = 'none'
                    link.href = url
                    link.setAttribute('download', '院校学生审核表.xlsx')    // 自定义下载文件名（如exemple.txt）
                    document.body.appendChild(link)
                    // this.errorData.errorButton = false
                    link.click()
                })
            }
            this.exportRouleVisible = false

        },
        //操作表格
        oprtation(row, eventType, type, index) {
            if (eventType === 'check') {
                if (type === 2) {
                    // 通过
                    this.userCheck(row.id)
                } else if (type === 3) {
                    // 不通过
                    this.userNotApprove(row.id)
                }
            } else if (eventType === 'show') {
                // this.srcList = [
                //     row.photoFrontUrl,
                //     row.photoBackUrl
                // ]
                // this.$nextTick(()=>{
                //     this.imgViewUrl = row.photoFrontUrl
                //     this.$refs.imgView.clickHandler();
                // })
                this.activeIndex = index
                this.imageDialog = true
            }
        },
        // 文件上传成功
        fileUploadSuccess(res) {
            if (res.code === '0') {
                this.$message({
                    type: 'success',
                    message: '上传成功！对应身份证号状态已修改'
                })
                this.getUserList()
            } else {
                this.$message({
                    type: 'error',
                    message: res.msg
                })
            }
        },
        // 文件上传失败
        fileUploadError() {
            this.$message({
                type: 'error',
                message: '上传失败！'
            })
        },
        // 单个审核成功
        userCheck(id) {
            auditFetch.setUserCheck({
                id
            }).then(res => {
                if (res.code === '0') {
                    this.$message({
                        type: 'success',
                        message: '操作成功'
                    })
                    this.getUserList()
                } else {
                    this.$message({
                        type: 'error',
                        message: res.msg
                    })
                }
            })
        },
        // 多个审核成功
        userBatchCheck() {
            if (this.selectList.length > 0) {
                this.$confirm('批量审核，是否确认？', '批量审核', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        let checkUserIdList = this.selectList.map(item => {
                            return item.id
                        })
                        auditFetch.setUserBatchCheck({
                            checkUserIdList
                        }).then(res => {
                            if (res.code === '0') {
                                this.$message({
                                    type: 'success',
                                    message: '操作成功'
                                })
                                this.getUserList()
                            } else {
                                this.$message({
                                    type: 'error',
                                    message: res.msg
                                })
                            }
                        })
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: '操作已取消。'
                        })
                    });

            } else {
                this.$message({
                    type: 'warning',
                    message: '至少选中一条进行操作！'
                })
            }

        },
        downloadFile() {
            // 图片的线上地址
            var imageUrl = this.tableData[this.activeIndex].photoUrl;
            // 使用 fetch 获取图片
            fetch(imageUrl)
                .then(response => response.blob())
                .then(blob => {
                    // 创建一个 URL 对象，用于生成临时链接
                    var url = window.URL.createObjectURL(blob);

                    // 创建一个 <a> 元素，设置下载链接并模拟点击
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = this.tableData[this.activeIndex].name;
                    document.body.appendChild(a);
                    a.click();
                    // 清理临时链接和 <a> 元素
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                })
                .catch(error => console.error('下载图片失败：', error));
        },
        // 审核 全部审核成功
        userAllCheck() {
            this.$confirm('全部通过，是否确认？', '全部通过', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    auditFetch.setUserAllCheck({
                        provinceId: 14
                    }).then(res => {
                        if (res.code === '0') {
                            this.$message({
                                type: 'success',
                                message: '操作成功'
                            })
                            this.getUserList()
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.msg
                            })
                        }
                    })
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '操作已取消。'
                    })
                });

        },
        // 审核， 单 个用户不通过 
        userNotApprove(id) {
            auditFetch.setUserNotApprove({
                id
            }).then(res => {
                if (res.code === '0') {
                    this.$message({
                        type: 'success',
                        message: '操作成功'
                    })
                    this.getUserList()
                } else {
                    this.$message({
                        type: 'error',
                        message: res.msg
                    })
                }
            })
        }
    }
}
</script>
<style scoped lang="scss">
.audit {
    background-image: url('~@/assets/audit/audit_back.jpg');
    background-size: 100% 50%;
    background-repeat: no-repeat;
    padding: 30px;
    height: 100vh;
    width: 100%;
    box-sizing: border-box;
    min-width: 1280px;

    .prev-box {
        margin-bottom: 20px;
        width: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        font-size: 15px;
        font-weight: 500;
        user-select: none;
        cursor: pointer;

        span:nth-child(2) {
            margin-bottom: 2px;
        }
    }

    .prev-box:hover {
        opacity: .85;
    }

    .table-box {
        box-sizing: border-box;
        padding: 20px;
        background: #ffffff;

        .scach-box {
            margin-bottom: 10px;
            display: flex;
            justify-content: space-between;

            .el-input {
                margin-right: 10px;
                width: 260px;
            }

            .right-box {
                display: flex;

                .el-button {
                    background: rgb(97, 131, 255);
                    color: #ffffff;
                    margin: 0 6px;
                }

                .el-button:hover {
                    opacity: .9;
                }
            }
        }

        /deep/ .el-table {
            .cell {
                text-align: center;
                font-weight: 400;
                font-size: 13px;
            }

            thead {
                tr th.el-table__cell {
                    background-color: rgb(244, 245, 247);
                }

                .cell {
                    font-weight: 500;
                    color: #000000;
                    font-size: 14px;
                }
            }

            tbody {
                td {
                    padding: 0;
                }
            }
        }

        .el-button {
            color: rgb(97, 131, 255);
            ;
        }

        .el-button:hover {
            opacity: .8;
        }
    }

    .pagination-box {
        box-sizing: border-box;
        padding: 0 20px;

        /deep/ .el-pagination {
            .el-pager {
                .active {
                    background: rgb(97, 131, 255);
                }

                .number:hover {
                    color: rgb(97, 131, 255);
                }
            }
        }
    }

    /deep/.img-view {
        display: none;
    }

    .form-box {
        .label_name {
            display: flex;
            justify-content: center;
            background-color: rgb(243, 245, 247);
            line-height: 28px;
            margin-right: 10px;
        }

        .planListCol {
            display: flex;
            flex-direction: column;


            .planRadioGroup {
                width: 100%;
                max-height: 400px;
                overflow-y: scroll;
                display: flex;
                flex-direction: column;

                .el-radio.is-bordered+.el-radio.is-bordered {
                    margin-left: 0;
                }

                .el-radio--mini.is-bordered {
                    padding: 6px 15px 6px 10px;
                    height: auto;
                }

                /deep/.el-radio__inner {
                    display: none;
                }

                .planRadio {
                    max-width: 325px;
                    margin-bottom: 6px;

                    // white-space: nowrap;
                    // overflow: hidden;
                    // text-overflow: ellipsis;
                    /deep/.el-radio__label {
                        max-width: 325px;
                        white-space: pre-wrap;
                        // overflow: hidden;
                        // text-overflow: ellipsis;
                        padding-left: 0px;
                    }

                }

                /deep/.is-checked {
                    background-color: #409EFF;

                    .el-radio__label {
                        color: #fff;

                    }
                }
            }
        }

        .el-row {
            margin-bottom: 10px;

            .el-radio,
            .el-date-editor {
                background-color: rgb(243, 245, 247);

                /deep/ .el-range-input {
                    background-color: rgb(243, 245, 247);
                }
            }
        }

        /deep/ .el-select,
        /deep/ .el-input {
            width: 100%;

            .el-input__inner {
                background-color: rgb(243, 245, 247);
            }
        }
    }
}</style>